exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#custom-preloader[data-v-b08a7e32]{width:75%;height:23em;top:0;bottom:0;display:flex;justify-content:center;align-items:center}.spinner-blue-only[data-v-b08a7e32]{border-color:#8344e9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b08a7e32","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SmallPreloader.vue
// module id = 270
// module chunks = 0